import React from 'react';
import AssetValuator from './AssetValuator';
import './App.css';

function App() {
  return (
    <div className="App">
      <AssetValuator />
    </div>
  );
}

export default App;